import { render, staticRenderFns } from "./IframeVideo.vue?vue&type=template&id=9db3e41e&scoped=true"
import script from "./IframeVideo.vue?vue&type=script&lang=js"
export * from "./IframeVideo.vue?vue&type=script&lang=js"
import style0 from "./IframeVideo.vue?vue&type=style&index=0&id=9db3e41e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db3e41e",
  null
  
)

export default component.exports